module.exports = __webpack_public_path__ + "static/media/logo-onoiwa-white.f1d3c1b9.png";